module.exports = __webpack_public_path__ + "static/media/bs3.a6994d48.webp";